// ----------------------------------------------------------------------
// <copyright file="Izenda.EmbedReportDetail.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

!(function() {
  var m = require('mobx');
  var EmbedReportPartDetail = require('./Izenda.EmbedReportPartDetail');
  const { map, split, filter, includes } = require('lodash/fp');

  function EmbedReportDetail(data) {
    var props = {
      id: null,
      name: null,
      reportParts: [],
      selectedReportParts: [] // List data of EmbedReportPartDetail object
    };

    m.extendObservable(this, props);
    data && this.populateData(data);
  }

  /**
   * Populate data
   * @param  {Object} embed report detail data
   */
  EmbedReportDetail.prototype.populateData = m.action(function(data) {
    this.id = data.id;
    this.name = data.name;
    this.reportParts = map(function(reportPart) {
      return new EmbedReportPartDetail(reportPart);
    }, data.reportPart);
  });

  /**
   * Populate data
   * @param  {Object} embed report detail data
   */
  EmbedReportDetail.prototype.setSelectedReportPart = m.action(function(ids) {
    var listId = split(',', ids);

    this.selectedReportParts = filter(function(reportPart) {
      return includes(reportPart.id, listId);
    }, this.reportParts);
  });

  module.exports = EmbedReportDetail;
})();



// WEBPACK FOOTER //
// ./ui/logic/models/Izenda.EmbedReportDetail.js